<template>
<div>
    <div class="mcc-page-header">
        <section class="mu-d-flex mu-w-100">
            <h1 class="mu-mb-00">Dashboard</h1>
            <details class="mcc-popover mcc-popover--bottom-end">
                <summary class="mcc-button mcc-button--icon-only ">
                    <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                </summary>
                <div class="mcc-popover__content">
                    <p class="mu-mb-00">
                        {{ helpText.title }}
                        <a :href="helpText.url" target="_blank">Read more...</a>
                    </p>
                </div>
            </details>
        </section>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb ">
                <li>Dashboard</li>
            </ol>
        </nav>
        <div class="mcc-row">
            <div class="mcc-col">
                <div style="position:relative">
                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <div class="mcc-tabs mcc-tabs--compact mcc-tabs--bar" active-index="0" @change="handleTabChange($event)">
                        <input type="radio" id="instances" name="as-default-tab-control" checked="" />
                        <input type="radio" id="taskTab" name="as-default-tab-control" />
                        <ul role="tablist" class="mu-bg-container-01 mu-pt-07 mu-pl-06 mu-radius-top-02 mu-border-top mu-border-start mu-border-end">
                            <li role="tab">
                                <label for="instances" tabindex="0">
                                    <span>Process instance</span>
                                </label>
                            </li>
                            <li role="tab">
                                <label for="taskTab" tabindex="0">
                                    <span>Task</span>
                                </label>
                            </li>
                        </ul>
                        <div role="tabpanel">
                            <div class="mcc-card mu-radius-top-00">
                                <div class="mcc-card__body">
                                    <div class="mcc-card">
                                        <div class="mcc-card__body">
                                            <div class="chart-content" style="height: 500px;" id="processByTime"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div role="tabpanel">
                            <div class="mcc-card mu-radius-top-00">
                                <div class="mcc-card__body">
                                    <div class="mcc-row mu-mx-00">
                                        <div class="mcc-col mcc-card mu-mr-03">
                                            <div class="mcc-card__body">
                                                <div class="mcc-row">
                                                    <div class="mcc-col">
                                                        <div class="chart-content" style="height: 500px;" id="taskStartedVsCompleted"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mcc-col mcc-card mu-mr-03">
                                            <div class="mcc-card__body">
                                                <div class="mcc-row">
                                                    <div class="mcc-col">
                                                        <div class="chart-content" style="height: 500px;" id="taskDueOverDue"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import constantMessages from "../../../messages";
import DashboardAPI from "../../../services/DashboardAPI";
import Utils from "@/script_utils";

export default {
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["user.dashboard"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            updateCall: true,
            taskLoaded: false,
            processDto: {},
            taskDto: {}
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        DashboardAPI.getUserProcessInfo()
            .then(result => {
                self.processDto = result;
            })
            .finally(() => {
                self.updateCall = true;
                self.loadInstanceCharts();
            });
    },
    methods: {
        async loadInstanceCharts() {
            await this.$nextTick();
            let self = this;
            let responseData = self.processDto;
            if (am4core && am4core.options) {
                am4core.options.commercialLicense = true;
            }
            setTimeout(function () {
                let userProcessesByTime = [];
                if (responseData && responseData.processByTime) {
                    userProcessesByTime = responseData.processByTime;
                }

                am4core
                    .ready(function () {
                        let chart = am4core.create("processByTime", am4charts.XYChart);
                        chart.data = userProcessesByTime;
                        let title = chart.titles.create();
                        title.text = "[bold]Processes completed by time[/]";
                        title.marginBottom = 30;
                        let categoryAxis = chart.yAxes
                            .push(new am4charts.CategoryAxis());
                        categoryAxis.dataFields.category = "processDefinitionName";
                        categoryAxis.renderer.inversed = true;
                        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
                        valueAxis.renderer.grid.template.disabled = true;
                        valueAxis.renderer.labels.template.disabled = true;
                        let series = chart.series.push(new am4charts.ColumnSeries());
                        series.dataFields.valueX = "durationInHours";
                        series.dataFields.categoryY = "processDefinitionName";
                        series.name = "DurationInHours";
                        series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
                        series.columns.template.tooltipText = "Duration: {prettyDurationInMillis}";
                        series.columns.template.fillOpacity = 0.5;
                        series.columns.template.height = am4core.percent(80);
                        chart.exporting.menu = new am4core.ExportMenu();
                        let annotation = chart.plugins
                            .push(new am4plugins_annotation.Annotation());
                    });
            }, 0);

        },
        handleTabChange(e) {
            let self = this;
            console.log("hello");
            if (e.target.id == "taskTab" && !self.taskLoaded) {
                self.taskLoaded = true;
                self.getTaskData();
            }
        },

        getTaskData() {
            let self = this;
            self.updateCall = false;
            DashboardAPI.getUserTaskInfo()
                .then(result => {
                    self.taskDto = result;
                })
                .finally(() => {
                    self.updateCall = true;
                    self.loadTaskData(self.taskDto);
                });
        },
        loadTaskData(responseData) {
            let self = this;
            if (responseData) {
                let taskGraphData = [{
                    "taskTitle": "Task completed",
                    "taskLength": responseData.completedTasks,
                    "taskType": "completedTasks"
                }, {
                    "taskTitle": "Tasks started",
                    "taskLength": responseData.inCompleteTask,
                    "taskType": "runningTask"
                }];

                am4core
                    .ready(function () {
                        am4core.useTheme(am4themes_animated);
                        let chart = am4core.create(
                            "taskStartedVsCompleted",
                            am4charts.XYChart3D);
                        let title = chart.titles.create();
                        title.text = "[bold]Tasks started Vs completed[/]";
                        title.marginBottom = 30;
                        chart.data = taskGraphData;
                        let categoryAxis = chart.xAxes
                            .push(new am4charts.CategoryAxis());
                        categoryAxis.dataFields.category = "taskTitle";
                        let valueAxis = chart.yAxes
                            .push(new am4charts.ValueAxis());
                        valueAxis.title.text = "[bold]Total[/]";
                        let series = chart.series
                            .push(new am4charts.ColumnSeries3D());
                        series.dataFields.valueY = "taskLength";
                        series.dataFields.categoryX = "taskTitle";
                        series.name = "TaskLength";
                        series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
                        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
                        series.columns.template.events
                            .on(
                                "hit",
                                function (event) {
                                    if (event.target.dataItem.categoryX == "Task completed") {
                                        localStorage
                                            .setItem(
                                                'completedTaskFilter',
                                                'completed');
                                    }
                                    self.$router.push(
                                        self.CONTEXT_PATH + "/tasks/assigned"
                                    );
                                }, this);
                        chart.exporting.menu = new am4core.ExportMenu();
                        let annotation = chart.plugins
                            .push(new am4plugins_annotation.Annotation());
                    });

            }
            if (responseData) {
                let overDueAndDueData = [{
                    "taskTitle": "Task over due",
                    "taskLength": responseData.overDueTasks
                }, {
                    "taskTitle": "Tasks due today",
                    "taskLength": responseData.dueTodayTasks
                }];

                am4core
                    .ready(function () {
                        am4core.useTheme(am4themes_animated);
                        let chart = am4core.create(
                            "taskDueOverDue",
                            am4charts.XYChart3D);
                        let title = chart.titles.create();
                        title.text = "[bold]Tasks due today Vs Tasks over due[/]";
                        title.marginBottom = 30;
                        chart.data = overDueAndDueData;
                        let categoryAxis = chart.xAxes
                            .push(new am4charts.CategoryAxis());
                        categoryAxis.dataFields.category = "taskTitle";
                        let valueAxis = chart.yAxes
                            .push(new am4charts.ValueAxis());
                        valueAxis.title.text = "[bold]Total[/]";
                        let series = chart.series
                            .push(new am4charts.ColumnSeries3D());
                        series.dataFields.valueY = "taskLength";
                        series.dataFields.categoryX = "taskTitle";
                        series.name = "TaskLength";
                        series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
                        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
                        chart.exporting.menu = new am4core.ExportMenu();
                        let annotation = chart.plugins
                            .push(new am4plugins_annotation.Annotation());
                    });
            }
        }
    }
}
</script>
